import api from "./api";

const layoutApi = {
  /**
   * ========================================================
   * Get Complete Layout
   * ========================================================
   *
   * Returns:
   * {
   *   categories: [...],
   *   paths: [...]
   * }
   */
  async getLayout() {
    try {
      const response = await api.get("/layout");

      return response.data;
    } catch (error) {
      console.error(
        "Failed to fetch layout:",
        error
      );

      throw (
        error?.response?.data ||
        new Error("Failed to fetch layout.")
      );
    }
  },

  /**
   * ========================================================
   * Save Complete Layout
   * ========================================================
   *
   * Payload:
   * {
   *   categories: [...],
   *   paths: [...]
   * }
   */
  async saveLayout(payload) {
    try {
      const response = await api.post(
        "/layout/save",
        payload
      );

      return response.data;
    } catch (error) {
      console.error(
        "Failed to save layout:",
        error
      );

      throw (
        error?.response?.data ||
        new Error("Failed to save layout.")
      );
    }
  },

  /**
   * ========================================================
   * Update Single Category
   * ========================================================
   */
  async updateLayoutItem(
    categoryId,
    item
  ) {
    try {
      const response = await api.put(
        `/layout/${categoryId}`,
        item
      );

      return response.data;
    } catch (error) {
      console.error(
        "Failed to update layout item:",
        error
      );

      throw (
        error?.response?.data ||
        new Error(
          "Failed to update layout item."
        )
      );
    }
  },

  /**
   * ========================================================
   * Delete Single Category
   * ========================================================
   */
  async deleteLayoutItem(
    categoryId
  ) {
    try {
      const response = await api.delete(
        `/layout/${categoryId}`
      );

      return response.data;
    } catch (error) {
      console.error(
        "Failed to delete layout item:",
        error
      );

      throw (
        error?.response?.data ||
        new Error(
          "Failed to delete layout item."
        )
      );
    }
  },

  /**
   * ========================================================
   * Reset Complete Layout
   * ========================================================
   */
  async resetLayout() {
    try {
      const response = await api.delete(
        "/layout/reset/all"
      );

      return response.data;
    } catch (error) {
      console.error(
        "Failed to reset layout:",
        error
      );

      throw (
        error?.response?.data ||
        new Error("Failed to reset layout.")
      );
    }
  },

  /**
   * ========================================================
   * Get Available Categories
   * ========================================================
   */
  async getAvailableCategories() {
    try {
      const response = await api.get(
        "/layout/available-categories"
      );

      return response.data;
    } catch (error) {
      console.error(
        "Failed to fetch categories:",
        error
      );

      throw (
        error?.response?.data ||
        new Error(
          "Failed to fetch categories."
        )
      );
    }
  },
};

export default layoutApi;